function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  transform: "translate(0.5 0.625)",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3911_117581)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.375 31.875C36.5176 31.875 39.875 28.5176 39.875 24.375C39.875 20.2324 36.5176 16.875 32.375 16.875C28.2324 16.875 24.875 20.2324 24.875 24.375C24.875 28.5176 28.2324 31.875 32.375 31.875ZM37.625 33.75H36.6465C35.3457 34.3477 33.8984 34.6875 32.375 34.6875C30.8516 34.6875 29.4102 34.3477 28.1035 33.75H27.125C22.7773 33.75 19.25 37.2773 19.25 41.625V44.0625C19.25 45.6152 20.5098 46.875 22.0625 46.875H42.6875C44.2402 46.875 45.5 45.6152 45.5 44.0625V41.625C45.5 37.2773 41.9727 33.75 37.625 33.75Z",
  fill: "#C1C1C1"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3911_117581"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26.25,
  height: 30,
  fill: "white",
  transform: "translate(19.25 16.875)"
})));

function SvgIcPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPerson);
export default __webpack_public_path__ + "static/media/ic_person.27810037.svg";
export { ForwardRef as ReactComponent };